import client from "shared/utils/axios-config";

export interface WaitlistEntryDto {
  id: string;
  // "waitlist" while live, "waitlist_expired" after the schedule's start_time
  // passes (lazy-cleanup keeps the row + waitlist_position for snapshot view).
  status: string;
  schedule_id: string;
  occurrence_timestamp: string;
  customer_id: string;
  customer_name: string;
  // E.164 phone of the waitlisted customer.
  customer_phone?: string | null;
  customer_package_id: string;
  customer_package_name: string;
  waitlist_position: number;
  joined_at: string;
  // Booking code, shared with the booking the entry becomes once promoted.
  booking_ref?: string | null;
  // False when the client is deactivated at the studio: the row is read-only.
  customer_active?: boolean;
  // Credits the spot holds (the class's cost on the package's tier).
  credit_cost?: number;
  // A membership spot holds none: the Kredit column reads a dash.
  package_unlimited?: boolean;
}

export interface AddToWaitlistForm {
  schedule_id: string;
  occurrence_timestamp: string;
  customer_id: string;
  customer_package_id: string;
  on_conflict?: "swap" | "extend";
}

export const getWaitlistByScheduleV2 = async (
  schedule_id: string,
  occurrence_timestamp: string,
): Promise<WaitlistEntryDto[]> => {
  const res = await client.get(
    `/v2/waitlist/schedule/${schedule_id}/${occurrence_timestamp}`,
  );
  return res.data.data;
};

export const addToWaitlistV2 = async (form: AddToWaitlistForm) => {
  const res = await client.post(`/v2/waitlist/`, form);
  return res.data;
};

export const removeFromWaitlistV2 = async (bookingId: string) => {
  const res = await client.delete(`/v2/waitlist/${bookingId}`);
  return res.data;
};

export const reorderWaitlistV2 = async (
  bookingId: string,
  newPosition: number,
) => {
  const res = await client.put(`/v2/waitlist/${bookingId}/position`, {
    new_position: newPosition,
  });
  return res.data;
};
